import { api } from "@/lib/api/client";

/** Avancement de la mise en route de la clinique active (« Premiers pas »). */
export interface SetupProgress {
  profile: boolean;
  catalogue: boolean;
  insurers: boolean;
  team: boolean;
  patient: boolean;
  consultation: boolean;
  sale: boolean;
  cash_closure: boolean;
}

export const helpApi = {
  setupProgress: async (): Promise<SetupProgress> => {
    const { data } = await api.get<SetupProgress>("/account/setup-progress/");
    return data;
  },
  /** Guide complet de la plateforme (PDF), réservé aux connectés — ADR 0046. */
  platformGuide: async (): Promise<Blob> => {
    const { data } = await api.get<Blob>("/help/guide/", { responseType: "blob" });
    return data;
  },
};
